import axios from 'axios';
import buildPaginationQueryOpts from '@/shared/sort/sorts';
import { metricOptionsVM } from '@/shared/model/metricOptionsVM.model';
const baseApiUrl = 'api/dashboard';
export default class HomeService {
  public device(isTR069: boolean): Promise<any> {
    return axios.get(baseApiUrl + `/device?isTR069=${isTR069}`);
  }
  public monitor(type): Promise<any> {
    return axios.get(baseApiUrl + `/monitor?type=${type}`);
  }
  public alert(isTR069: boolean): Promise<any> {
    return axios.get(baseApiUrl + `/alert?isTR069=${isTR069}`);
  }
  public alertByDevice(isTR069: boolean): Promise<any> {
    return axios.get(baseApiUrl + `/alert-by-device?isTR069=${isTR069}`);
  }

  public deviceCountByModelName(provisioningMode: string): Promise<any> {
    return axios.get(baseApiUrl + `/count-by-model-and-version?provisioningMode=${provisioningMode}`);
  }

  public deviceCountByCriticalPowerThreshold(orgId: number): Promise<any> {
    return axios.get(baseApiUrl + `/count-by-critical-power-threshold/${orgId}`);
  }

  public deviceCountByWifi() {
    return axios.get(baseApiUrl + `/count-by-wifi-clients`);
  }

  public deviceCountByLan() {
  return axios.get(baseApiUrl + `/count-by-lan-clients`);
  }

  public countByWarnPowerThresHold(orgId: number): Promise<any> {
    return axios.get(baseApiUrl + `/count-by-warn-power-threshold/${orgId}`);
  }

  public generateOpticalPowerThresholdReport(threshold): Promise<any> {
    return axios.get(`/api/device/optical-power-threshold-summary-report?threshold=${threshold}`, { responseType: 'blob' });
  }

  public generateLanVsWifiClientsReport(lanVsWifi) {
     return axios.get(baseApiUrl + `/lan-vs-wifi-report?lanVsWifi=${lanVsWifi}` , { responseType: 'blob'});
  }

  public generateAssociatedActiveHostDeviceReport(range: string): Promise<any> {
    return axios.get(`api/dashboard/assoicated-active-host-device-report?range=${range}`, { responseType: 'blob'});
  }

  public generateAssociatedActiveHostDeviceReportView(range: string , paginationQuery): Promise<any> {
    return axios.get(baseApiUrl + `/assoicated-active-host-device-report-view?range=${range}&${buildPaginationQueryOpts(paginationQuery)}`);
  }

  public generateUnlinkDeviceReport(onProgress?: (progress: { loaded: number }) => void): Promise<any> {
   return new Promise<any>((resolve, reject) => {
            axios
                .get('api/device/unlink-device-report', {
                    responseType: 'blob',
                    onDownloadProgress: (progressEvent: ProgressEvent) => {
                        if (onProgress) {
                            onProgress({
                                loaded: progressEvent.loaded,
                            });
                        }
                    }
                })
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                })
        });
  }

  public generateOfflineDeviceReport(isTR069: boolean,onProgress?: (progress: { loaded: number }) => void): Promise<any> {
    return new Promise<any>((resolve, reject) => {
            axios
                .get('api/dashboard/device/offline-device-report', {
                  params: { isTR069 },
                    responseType: 'blob',
                    onDownloadProgress: (progressEvent: ProgressEvent) => {
                        if (onProgress) {
                            onProgress({
                                loaded: progressEvent.loaded,
                            });
                        }
                    }
                })
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                })
        });
  }

  public generateDeviceChurnReport(isTR069: boolean, timePeriod: string): Promise<any> {
    return axios.get('api/dashboard/device/churn-device-report', {
      params: { isTR069, timePeriod },
      responseType: 'blob',
    });
  }

  public devicePortPowerThresholdIssue(metricOptionsVM: metricOptionsVM, thresholdName: string, paginationQuery): Promise<any> {
    let url = null;
    if (metricOptionsVM.period == undefined && metricOptionsVM.timezoneOffset == undefined) {
      url = `${baseApiUrl}/device-having-port-power-issue?threshold=${thresholdName}&${buildPaginationQueryOpts(paginationQuery)}`;
    } else {
      const postdate = `period=${metricOptionsVM.period}&timezoneOffset=${metricOptionsVM.timezoneOffset}`;
      url = `${baseApiUrl}/device-having-port-power-issue?threshold=${thresholdName}&${postdate}&${buildPaginationQueryOpts(
        paginationQuery
      )}`;
    }
    return new Promise<any>((resolve, reject) => {
      axios
        .get(url)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public lanVsWifiClientsReportView(lanVsWifi: string, paginationQuery): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/lan-vs-wifi-report-view?lanVsWifi=${lanVsWifi}&${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public deviceDiscoveryReportView(date, paginationQuery): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/device-discovery-report-view?date=${date}&${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public deviceDiscoveryReport(days: number, interval: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/device-discovery-report?days=${days}&interval=${interval}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public deviceChurnCount(isTR069: boolean) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/device/churn-device-count?isTR069=${isTR069}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        })
    })
  }

   public deviceAssociatedActiveHostCount() {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/count-by-assoicated-active-host`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        })
    })
  }

  public deviceChurnView(isTR069: boolean, timePeriod: string, paginationQuery:any, afterKey: Object[]) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/device/churn-device-view?isTR069=${isTR069}&timePeriod=${timePeriod}&${buildPaginationQueryOpts(paginationQuery)}`, afterKey)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        })
    })
  }

  public deviceBandSteeringSupportCount(isTR069: boolean) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/device/band-steering-support-count?isTR069=${isTR069}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        })
    })
  }

 public generateDeviceBandSteeringSupportReport(bandSteeringSupport, isTR069: boolean, onProgress?: (progress: { loaded: number }) => void): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/device/band-steering-support-report?bandSteeringSupport=${bandSteeringSupport}&isTR069=${isTR069}`, {
          responseType: 'blob',
          onDownloadProgress: (progressEvent: ProgressEvent) => {
            if (onProgress) {
              onProgress({
                loaded: progressEvent.loaded,
              });
            }
          }
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        })
    })
  }

  public deviceByStatusWithBandSteeringSupportEnableCount(isTR069: boolean) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/device/band-steering-status-count?isTR069=${isTR069}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        })
    })
  }

  public generateDeviceByStatusWithBandSteeringSupportEnableReport(bandSteeringStatus, isTR069: boolean, onProgress?: (progress: { loaded: number }) => void): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/device/band-steering-status-report?bandSteeringStatus=${bandSteeringStatus}&isTR069=${isTR069}`, {
          responseType: 'blob',
          onDownloadProgress: (progressEvent: ProgressEvent) => {
            if (onProgress) {
              onProgress({
                loaded: progressEvent.loaded,
              });
            }
          }
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        })
    })
  }
}
